module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "md4 xs12 order-list"
  }, [_c('v-container', {
    staticClass: "card-container",
    staticStyle: {
      "flex-direction": "column"
    },
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "fluid": "",
      "d-flex": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('strong', {
    staticClass: "fs-18 "
  }, [_vm._v("\n          Pedido ref.:   \n        ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-18 titulo-detalhes "
  }, [_vm._v(" " + _vm._s(_vm.value.identifier) + " ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm._f("calendar")(_vm.value.date)) + "\n      ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_vm._v("\n        " + _vm._s(_vm.value.condominium.name)), _c('br'), _vm._v("\n        Cliente: " + _vm._s(_vm.value.client)), _c('br'), _vm._v("\n        Unidade: " + _vm._s(_vm.value.unit)), _c('br')])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-2": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_c('strong', [_vm._v("Itens Pedidos")]), _c('br'), _vm._v(" "), _vm._l((_vm.value.itens), function(item) {
    return [_c('span', [_vm._v("\n            " + _vm._s(item.name) + ";\n          ")])]
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-end": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "fs-18 mt-1"
  }, [_c('strong', [_vm._v("Valor total")]), _vm._v(": " + _vm._s(_vm._f("currency")(_vm.price)) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "elevation-0 order-details-btn ma-0",
    on: {
      "click": function($event) {
        return _vm.orderDetails(_vm.value.id)
      }
    }
  }, [_vm._v("+ detalhes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2354688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/pedidos/OrderList/order.vue
// module id = 431
// module chunks = 18 19 20 21